'use client';

import { Box, Card, CardContent, Skeleton } from '@mui/material';

import { Topbar } from '@/components/layout';

export const ActivitySkeleton = () => (
  <Box>
    <Topbar title="Activity" />
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {[1, 2, 3].map((i) => (
        <Card key={i} sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
          <CardContent>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={20} sx={{ mt: 1 }} />
          </CardContent>
        </Card>
      ))}
    </Box>
  </Box>
);
